import React from 'react';
import styled from 'styled-components';
import useLockBodyScroll from '@com/core/common/hooks/useLockBodyScroll';

type TBackgroundType = 'blur' | 'dark';

type TProps = {
    isPanelOpen: boolean;
    isClicked: () => void;
    type?: TBackgroundType;
};

const Overlay = ({ isClicked, isPanelOpen, type = 'dark' }: TProps): JSX.Element => {
    useLockBodyScroll();
    return <Scrim isPanelOpen={isPanelOpen} onClick={isClicked} type={type} />;
};

const Scrim = styled.div<{ isPanelOpen: boolean; type: TBackgroundType }>`
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    ${({ type }): string => (type === 'blur' ? 'backdrop-filter: blur(4px)' : '')};
    ${({ isPanelOpen }): string => `pointer-events: ${isPanelOpen ? 'auto' : 'none'}`};
`;

export default Overlay;
